<template>
  <div class="notice-board" v-if="goldJobs.length > 0 || silverAndBronzeJobs.length > 0">
    <h2 class="notice-board__title">Oglasna ploča</h2>
    <template v-if="goldJobs.length > 0">
      <h3 class="notice-board__subtitle">Oglasi zlatnih sponzora</h3>
      <JobList v-bind:jobs="goldJobs" v-bind:isLogoVisible="true" v-bind:sponsorCategory="'Gold'" />
    </template>
    <template v-if="silverAndBronzeJobs.length > 0">
      <h3 class="notice-board__subtitle">Oglasi srebrnih sponzora</h3>
      <JobList v-bind:jobs="silverAndBronzeJobs" v-bind:isLogoVisible="true" v-bind:sponsorCategory="'Silver'" />
    </template>
  </div>
</template>

<script>
import JobList from './JobList';

export default {
  name: 'NoticeBoard',
  components: {
    JobList,
  },
  computed: {
    silverAndBronzeJobs: function() {
      return this.$store.getters['landing/silverAndBronzeJobs'];
    },
    goldJobs: function() {
      return this.$store.getters['landing/goldJobs'];
    },
  },
};
</script>

<style scoped>
.notice-board {
  padding: 0 100px;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .notice-board {
    padding: 0 16px;
  }
}

.notice-board__title {
  font-size: 48px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 80px;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .notice-board__title {
    font-size: 32px;
    line-height: 38px;
  }
}

.notice-board__subtitle {
  font-size: 32px;
  font-weight: 800;
  line-height: 38px;
  color: #30cec2;
  margin-bottom: 48px;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .notice-board__subtitle {
    font-size: 24px;
    line-height: 36px;
  }
}
</style>
